import cx from 'classnames';
import i18next from 'i18next';

import { DefaultPaymentTypeCode } from 'enums';
import {
  MonitoringAlertLevel,
  MonitoringAmountRange,
  MonitoringDataItem,
} from 'types';

function getRangeLabel(range: MonitoringAmountRange) {
  return range.max ? `${range.min} - ${range.max}` : `${range.min}+`;
}

function getPaymentTypeHeader(paymentType: DefaultPaymentTypeCode) {
  const tKey = `features.orders_monitoring.columns.${paymentType}`;
  return i18next.exists(tKey)
    ? i18next.t(tKey as any)
    : i18next.t(`payment_types.${paymentType}` as any);
}

function getAmountRangeCell(value?: MonitoringDataItem) {
  return (
    <div
      className={cx('tw-bg-gradient-to-l tw-p-4 tw-text-center', {
        'tw-from-red-300': value?.alertLevel === MonitoringAlertLevel.Low, // reversed colors
        'tw-from-yellow-300': value?.alertLevel === MonitoringAlertLevel.Medium,
        'tw-from-green-300': value?.alertLevel === MonitoringAlertLevel.High,
      })}
    >
      {value?.label}
    </div>
  );
}

export const orderMonitoringUtils = {
  getRangeLabel,
  getAmountRangeCell,
  getPaymentTypeHeader,
};
